module.exports = __webpack_public_path__ + "static/media/google-analytics.c13c8ddc.svg";